import { useCallback, useEffect } from 'react';

export function useTitleObserver(onTitleChange: (title: string, url: string) => void) {
  const handleMutation = useCallback(
    (mutations: MutationRecord[]) => {
      for (const mutation of mutations) {
        if (mutation.target.nodeName === 'TITLE') {
          onTitleChange(document.title, window.location.href);
        }
      }
    },
    [onTitleChange]
  );

  useEffect(() => {
    const titleElement = document.querySelector('title');
    if (!titleElement) {
      return;
    }

    const observer = new MutationObserver(handleMutation);

    observer.observe(titleElement, {
      subtree: true,
      characterData: true,
      childList: true
    });

    return () => {
      observer.disconnect();
    };
  }, [handleMutation]);
}
